<div class="modal-header">
  <h4 class="modal-title pull-left">{{actionLabel}}</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="onCloseModal()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="salvar()" (keydown.enter)="$event.preventDefault()">
    <div class="form-group row m-b">
      <div class="col-md-12">
        <label class="col-12">Título</label>
        <textarea class="form-control" formControlName="title"></textarea>
        <app-field-message [field]="fieldMessageRequired('title')" [erros]="fieldErros('title')"></app-field-message>
      </div>
    </div>
    <div class="form-group row m-b">
      <div class="col-md-12">
        <label class="col-12">Descrição</label>
        <textarea class="form-control" formControlName="description"></textarea>
        <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
      </div>
    </div>
    <div class="form-group row m-b">
      <div class="col-md-12">
        <label class="col-12">Arquivo</label>
        <input type="file" id="file" class="form-control" formControlName="file" (change)="onFileSelected($event)" [required]="!entity"/>
        <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
      </div>
    </div>
    <div class="form-group row m-b">
      <div class="col-md-12">
        <label class="col-12">Arquivo Atual</label>
        <div><span>Arquivo: </span><a href="#">{{data?.name}}</a></div>
        <div><span>Autor: </span>{{data?.owner}}</div>
        <div><span>Criado em: </span>{{data?.created_at | date: 'dd/MM/YYYY H:mm:s'}}</div>
      </div>
    </div>
    
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-danger m-r-xs" type="button" (click)="onExcluir()">Excluir</button>
        <button class="btn btn-primary" type="submit">Salvar</button>
      </div>
    </div>
  </form> 
</div>
<app-loading [loader]="isLoading"></app-loading>